import { render } from "./Shields.vue?vue&type=template&id=a6e737ea&scoped=true"
import script from "./Shields.vue?vue&type=script&lang=js"
export * from "./Shields.vue?vue&type=script&lang=js"

import "./Shields.vue?vue&type=style&index=0&id=a6e737ea&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\dinho\\Documents\\GitHub\\Grajaú-E-SPORTS\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6e737ea"]])

export default __exports__